module.exports = __webpack_public_path__ + "media/images/partnership-categories-organize-9cce43816b451c477f11fff607d733e6.png";